import React from "react";
import { Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { Form, Formik, ErrorMessage } from "formik";
import {updateUserDetails as updateAdminUserApi} from "../../../../../../api/admin/users";
import { Prompt } from "react-router";
import {Messages} from "../../../../../layout/Messages/Messages";
import {scrollToErrors} from "../../../../../../helpers/general";
import {NOTIFICATION_ADMIN_ACTIONS} from "../../../../../../config/notifications";
import {EditAdminProfileSchema} from "../../../../../../helpers/schemas";
import {AdminFields} from "./AdminFields";
import {store} from "../../../../../../store/store";
import {hideNotification} from "../../../../../../store/actions/notification";
import {NOTIFICATION_ERROR} from "../../../../../../store/actions/types";


function AdminEditForm(props) {
  const { user, toggleEditMode, updateUser } = props;

  const submitForm = (values) => {
    const payload = {
      data: {
        id: user.id,
        first_name: values.firstName,
        last_name: values.lastName,
        email: values.email,
      },
      notificationId: NOTIFICATION_ADMIN_ACTIONS
    };

    updateAdminUserApi( payload ).then( (response) => {
      if (response && response.data && response.data.id) {
        toggleEditMode( "user", false );
        updateUser( response.data );
      }
    } );
  };

  return (
    <div className="admin-user-detail-section admin-user-detail-section--edit">
        <Formik
          key="add_user"
          initialValues={{
            firstName: user.first_name || "",
            lastName: user.last_name || "",
            email: user.email || "",
          }}
          validationSchema={EditAdminProfileSchema}
          validateOnChange={false}
          onSubmit={submitForm}
        >
          {(props) => {
            scrollToErrors(props)
            return (
              <Form>
                <div className="mx-2">
                  <Messages color="danger" formikProps={props}>
                    <ErrorMessage
                      name="firstName"
                      component="div"
                      data-testid="errors-firstName"
                      className="field-error"
                    />
                    <ErrorMessage
                      name="lastName"
                      component="div"
                      data-testid="errors-lastName"
                      className="field-error"
                    />
                    <ErrorMessage
                      name="email"
                      component="div"
                      data-testid="errors-email"
                      className="field-error"
                    />
                  </Messages>
                </div>

                <Prompt
                  when={props.initialValues !== props.values}
                  message={(location) =>
                    `You have unsaved changes, are you sure you want to leave the form?`
                  }
                />

                <AdminFields formikProps={props} user={user}/>

                <div className="text-right py-3">
                  <Button name="save" type="submit" color="primary">
                    <FormattedMessage id="button.save"/>
                  </Button>
                  <Button
                    color="secondary"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      if (store.getState().notification.type === NOTIFICATION_ERROR) {
                        store.dispatch(hideNotification());
                      }
                      toggleEditMode( "user", false );
                    }}
                  >
                    <FormattedMessage id="button.cancel"/>
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
    </div>
  );
}

export { AdminEditForm };
